/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_PoolInputs */

const en_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const ar_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#مجموعة`)
};

const bn_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const de_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const es_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const fr_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const pt_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const zh_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const tr_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const ru_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

const pl_svtag_pool = /** @type {(inputs: Svtag_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POOL`)
};

/**
* | output |
* | --- |
* | "#POOL" |
*
* @param {Svtag_PoolInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_pool = /** @type {((inputs?: Svtag_PoolInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_PoolInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_pool(inputs)
	if (locale === "bn") return bn_svtag_pool(inputs)
	if (locale === "de") return de_svtag_pool(inputs)
	if (locale === "es") return es_svtag_pool(inputs)
	if (locale === "fr") return fr_svtag_pool(inputs)
	if (locale === "pt") return pt_svtag_pool(inputs)
	if (locale === "zh") return zh_svtag_pool(inputs)
	if (locale === "tr") return tr_svtag_pool(inputs)
	if (locale === "ru") return ru_svtag_pool(inputs)
	if (locale === "pl") return pl_svtag_pool(inputs)
	return en_svtag_pool(inputs)
});